import { render } from "./CheckoutContainerAllocated.vue?vue&type=template&id=b3b7b356"
import script from "./CheckoutContainerAllocated.vue?vue&type=script&lang=js"
export * from "./CheckoutContainerAllocated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__